<template>
  <div class="bottom-controls">
    <GruButton :disabled="!gameStarted" @click="$emit('reset')">
      New Game
    </GruButton>
  </div>
</template>

<script>
import GruButton from './GruButton.vue'

export default {
  name: 'BottomControls',
  components: { GruButton },
  props: ['gameStarted'],
}
</script>

<style scoped>
.bottom-controls {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f5f5f5;
}
</style>
